/**
 * Multipack Discount Quick-Add
 * Adds the discount quantity directly to cart with one click.
 * Reads variant ID from the product form at click time.
 * Dispatches cart:update to trigger cart drawer open and morph.
 */
(function() {
  'use strict';

  var SUCCESS_DURATION = 2000;
  var ERROR_DURATION = 5000;

  function initButton(button) {
    if (button.dataset.quickAddInit === 'true') return;
    button.dataset.quickAddInit = 'true';

    var textEl = button.querySelector('.product__multipack-quick-add-text');
    var loadingEl = button.querySelector('.product__multipack-quick-add-loading');
    var successEl = button.querySelector('.product__multipack-quick-add-success');
    var errorEl = button.parentElement.querySelector('.product__multipack-quick-add-error');
    var quantity = parseInt(button.dataset.quantity, 10);

    if (!textEl || !loadingEl || !successEl || !quantity) return;

    function getVariantId() {
      var form = button.closest('product-form-component, .product-form, [data-product-form]');
      if (!form) {
        form = document.querySelector('product-form-component');
      }
      if (!form) return null;
      var input = form.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    function enableIfVariant() {
      var variantId = getVariantId();
      button.disabled = !variantId;
    }

    function setState(state) {
      textEl.hidden = state !== 'default';
      loadingEl.hidden = state !== 'loading';
      successEl.hidden = state !== 'success';
      button.disabled = state === 'loading' || state === 'success';
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      setTimeout(function() {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }, ERROR_DURATION);
    }

    button.addEventListener('click', function() {
      var variantId = getVariantId();
      if (!variantId) {
        showError('Valitse ensin koko tai malli.');
        return;
      }

      setState('loading');

      // Collect section IDs for cart drawer morph (matches product-form.js pattern)
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function(el) {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: quantity }],
          sections: sectionIds.join(',')
        })
      })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(data) {
              throw new Error(data.description || data.message || 'Tuntematon virhe');
            });
          }
          return response.json();
        })
        .then(function(data) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            detail: {
              resource: data,
              data: { sections: data.sections || {} }
            }
          }));
          setState('success');
          setTimeout(function() {
            setState('default');
            enableIfVariant();
          }, SUCCESS_DURATION);
        })
        .catch(function(err) {
          setState('default');
          enableIfVariant();
          if (err.message && err.message !== 'Failed to fetch') {
            showError(err.message);
          } else {
            showError('Yhteysvirhe. Yrit\u00E4 uudelleen.');
          }
        });
    });

    // Enable button when variant is available
    enableIfVariant();

    // Listen for variant changes
    document.addEventListener('variant:update', function() {
      if (button.dataset.quickAddInit === 'true') {
        enableIfVariant();
      }
    });

    // Also listen for change events on variant selectors (fallback)
    var productSection = button.closest('.shopify-section');
    if (productSection) {
      productSection.addEventListener('change', function(e) {
        var target = e.target;
        if (target.matches('select, input[type="radio"]')) {
          setTimeout(enableIfVariant, 50);
        }
      });
    }
  }

  function checkForButtons() {
    var buttons = document.querySelectorAll('.product__multipack-quick-add');
    buttons.forEach(function(btn) {
      if (btn.dataset.quickAddInit !== 'true') {
        initButton(btn);
      }
    });
  }

  // Poll for buttons (handles lazy hydration)
  checkForButtons();
  var pollInterval = setInterval(checkForButtons, 500);
  setTimeout(function() {
    clearInterval(pollInterval);
  }, 30000);

  // Re-check after variant updates
  document.addEventListener('variant:update', function() {
    setTimeout(checkForButtons, 100);
  });
})();
